import { EMPTY_ARRAY } from 'src/constants';
import { useEffect } from 'react';
import { EventEmitter } from 'src/utils/event';

function useEventEffect(callback, eventName, deps = EMPTY_ARRAY) {
  useEffect(() => {
    EventEmitter.on(eventName, callback);

    return () => EventEmitter.clear(eventName, callback);
  }, deps);
}

export default useEventEffect;
